/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createHook } from '../../core/factories/createHook.js';

import { createPrefetchHook } from '../../core/factories/createPrefetchHook.js';
import type { GetThesisRow } from '../openapi-types.gen.js';
import { type useGetThesisArgs, useGetThesisSpec } from '../specs/theses.spec.gen.js';

export type { GetThesisRow } from '../openapi-types.gen.js';
export type { useGetThesisArgs } from '../specs/theses.spec.gen.js';


/**
 * Available query params (forwarded automatically; pass via the
 * hook's args): signature.
 */
const _useGetThesis = createHook(useGetThesisSpec);
export const useGetThesis = _useGetThesis as (args: useGetThesisArgs, opts?: import('../../core/factories/createHook.js').CreateHookCallOpts) => ReturnType<typeof _useGetThesis>;


/**
 * Hover/intent prefetch companion for `useGetThesis`. Returns a stable
 * `(args) => Promise<void>` callback that fires the real HTTP request
 * and writes the response into the SAME cache entry the reader hook
 * observes. The component owning the callback does NOT subscribe — no
 * re-renders on data, no NATS subscription. Idempotent: TanStack
 * `prefetchQuery` is a no-op when a fresh cache entry already exists.
 *
 *     function Link({ pubkey }) {
 *       const prefetch = usePrefetchGetThesis();
 *       return (
 *         <a
 *           onMouseEnter={() => prefetch({ pubkey })}
 *           onFocus={() => prefetch({ pubkey })}
 *         >…</a>
 *       );
 *     }
 */
export const usePrefetchGetThesis = createPrefetchHook(useGetThesisSpec) as () => import('../../types/SdkPrefetchTask.js').SdkPrefetcher<useGetThesisArgs>;
